import { SiteUrls } from '@tableau/shared-urls';

import { Messages } from '../../codegen/Localize';
import { SiteRoles } from '../../ts/ServerApi/types/ISiteRole';
import { HelpService } from '../../ts/services/HelpService';
import { WelcomeScreenStateProps } from '../components/WelcomeScreen';
import { WelcomeScreenLinks } from './WelcomeScreenLinks';

export class WelcomeScreenPropsByRole {
  private links: WelcomeScreenLinks;

  constructor(siteUrls: SiteUrls, helpService: HelpService) {
    this.links = new WelcomeScreenLinks(siteUrls, helpService);
  }

  getProps(role: string, isWebAuthoringEnabled: boolean): WelcomeScreenStateProps {
    switch (role) {

      case SiteRoles.ServerAdministrator:
      case SiteRoles.SiteAdministratorCreator:
      case SiteRoles.SupportUser:
        return {
          header: Messages.home_welcomeScreen_HeaderAdmin(),
          subHeader: Messages.home_welcomeScreen_SubheaderAdmin(),
          primaryButtonLink: this.createWorkbookIfWebAuthoringEnabled(isWebAuthoringEnabled),
          bottomLinks: [
            this.links.manageProjects(),
            this.links.manageUsers(),
            this.links.downloadDesktop(),
            this.links.downloadPrep(),
          ],
        };

      case SiteRoles.SiteAdministratorExplorer:
        return {
          header: Messages.home_welcomeScreen_HeaderAdmin(),
          subHeader: Messages.home_welcomeScreen_SubheaderAdmin(),
          primaryButtonLink: this.links.manageProjects(),
          bottomLinks: [
            this.links.manageUsers(),
            this.createWorkbookIfWebAuthoringEnabled(isWebAuthoringEnabled),
          ],
        };

      case SiteRoles.Creator:
        return {
          header: Messages.home_welcomeScreen_HeaderNonAdmin(),
          subHeader: Messages.home_welcomeScreen_SubheaderNonAdmin(),
          primaryButtonLink: this.createWorkbookIfWebAuthoringEnabled(isWebAuthoringEnabled),
          bottomLinks: [
            this.links.downloadDesktop(),
            this.links.downloadPrep(),
          ],
        };

      case SiteRoles.Explorer:
      case SiteRoles.ExplorerCanPublish:
        return {
          header: Messages.home_welcomeScreen_HeaderNonAdmin(),
          subHeader: Messages.home_welcomeScreen_SubheaderNonAdmin(),
          primaryButtonLink: this.links.startExploring(),
          bottomLinks: [],
        };

      case SiteRoles.Viewer:
      case SiteRoles.Guest:
        return {
          header: Messages.home_welcomeScreen_HeaderNonAdmin(),
          subHeader: Messages.home_welcomeScreen_SubheaderNonAdmin(),
          primaryButtonLink: this.links.startExploring(),
          bottomLinks: [],
        };

      default:
        return {
          header: Messages.home_welcomeScreen_HeaderNonAdmin(),
          subHeader: Messages.home_welcomeScreen_SubheaderNonAdmin(),
          primaryButtonLink: this.links.startExploring(),
          bottomLinks: [],
        };
    }
  }

  // TFS 960183: Create Workbook needs to respect web authoring enabled/disabled setting
  createWorkbookIfWebAuthoringEnabled(isWebAuthoringEnabled: boolean) {
    return isWebAuthoringEnabled ? this.links.createWorkbook() : this.links.startExploring();
  }
}
